import { InvoiceSendOptions } from '../../../domain/invoicing/invoicingApi'
import { InvoicingSettings } from '../../../domain/invoicing/settings/invoicingSettings'
import { getDefaultDueDate } from '../Creation/createInvoiceModel'

export const initialInvoiceSendOptions = (settings: InvoicingSettings): InvoiceSendOptions => ({
  dueOn: getDefaultDueDate(settings),
  enableCreditCardPayments: settings.defaultPaymentMethods.creditCard,
  enableAchPayments: settings.defaultPaymentMethods.ach,
  showAuthorizePaymentOnFile: settings.defaultAuthorizationForPaymentOnFile.showAuthorizePaymentOnFile,
  requireAuthorizePaymentOnFile: settings.defaultAuthorizationForPaymentOnFile.requireAuthorizePaymentOnFile,
})

export const isBulkSendSubmitDisabled = (selectedCount: number, isLoading: boolean): boolean => {
  return isLoading || selectedCount === 0
}
